import { isFunction } from '../../lodash';
import { Emoji } from '../yfm/Emoji';
import { ClicksOnEdges } from './ClicksOnEdges';
import { Clipboard } from './Clipboard';
import { CodeBlockHighlight } from './CodeBlockHighlight';
import { CommandMenu } from './CommandMenu';
import { Cursor } from './Cursor';
import { FilePaste } from './FilePaste';
import { History } from './History';
import { ImgSizeAdditions } from './ImgSizeAdditions';
import { LinkEnhance } from './LinkEnhance';
import { Placeholder } from './Placeholder';
import { ReactRendererExtension } from './ReactRenderer';
import { Selection } from './Selection';
import { SelectionContext } from './SelectionContext';
import { TableContextExtension } from './TableContext';
import { WidgetDecoration } from './WidgetDecoration';
import { YfmFileAdditions } from './YfmFileAdditions';
import { YfmNoteTooltip } from './YfmNoteTooltip';
import { YfmTableAdditions } from './YfmTableAdditions';
export * from './Cursor';
export * from './History';
export * from './Clipboard';
export * from './Selection';
export * from './Placeholder';
export * from './ReactRenderer';
export const BehaviorPreset = (builder, opts) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    builder
        .use(Selection)
        .use(Placeholder, (_a = opts.placeholder) !== null && _a !== void 0 ? _a : {})
        .use(Cursor, (_b = opts.cursor) !== null && _b !== void 0 ? _b : {})
        .use(History, (_c = opts.history) !== null && _c !== void 0 ? _c : {})
        .use(Clipboard, (_d = opts.clipboard) !== null && _d !== void 0 ? _d : {})
        .use(ReactRendererExtension, opts.reactRenderer);
    builder.use(WidgetDecoration).use(SelectionContext, (_e = opts.selectionContext) !== null && _e !== void 0 ? _e : {});
    builder.use(TableContextExtension).use(LinkEnhance, (_f = opts.link) !== null && _f !== void 0 ? _f : {});
    if (isFunction(opts.codeBlock)) {
        builder.use(opts.codeBlock);
    }
    else {
        builder.use(CodeBlockHighlight, (_g = opts.codeBlock) !== null && _g !== void 0 ? _g : {});
    }
    builder
        .use(ImgSizeAdditions, (_h = opts.imgSize) !== null && _h !== void 0 ? _h : {})
        // .use(YfmHeadingAdditions)
        .use(YfmNoteTooltip)
        .use(YfmFileAdditions, (_j = opts.yfmFile) !== null && _j !== void 0 ? _j : {})
        .use(YfmTableAdditions);
    if (opts.emoji) {
        builder.use(Emoji, opts.emoji);
    }
    if (opts.commandMenu)
        builder.use(CommandMenu, opts.commandMenu);
    builder.use(FilePaste);
    builder.use(ClicksOnEdges);
};
